import { Injectable } from "@angular/core";
import { Http, Response, ResponseContentType } from "@angular/http";

import { BASE_CONSTANTS, BASE_URLS, TCIToolDownloadType } from "@tci/common";
import { Observable } from "rxjs";
import { NgToolsService } from "../../ng-shared/ng-util/ng-tools.service";

@Injectable()
export class BaseHybridAgentDownloadService {
    constructor(
        private http: Http,
        private tools: NgToolsService
    ) {}

    public getProductVersion() {
        const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TOOLS_VERSION}/${TCIToolDownloadType.hybridAgent}`;
        return this
            .http
            .get(url)
            .catch((error) => {
                return Observable.of(null);
            })
            .map(res => {
                return res && res.json() || null;
            });
    }

    public download(url: string, os: string, arch: string): Observable<any> {
        return this
            .getFileContent(url, {
                os,
                arch
            })
            .map(
                (fileContent: { [key: string]: Blob }) => {
                    const keys: string[] = Object.keys(fileContent);
                    if (keys.length > 0) {
                        const fileName = keys[0];

                        this.launchDownload(fileContent[fileName], fileName);
                    }
                }
            );
    }

    private getFileContent(url: string, body: any): Observable<{ [key: string]: Blob }> {
        return this
            .http
            .post(url, body, {
                responseType: ResponseContentType.Blob
            })
            .map((res: Response) => {
                return {
                    [this.extractFileName(res.headers.get("Content-Disposition"))]: res.blob()
                };
            })
            .catch((error) => {
                console.log(error);
                return Observable.of({});
            });
    }

    private launchDownload(fileContent: Blob, fileName: string): void {
        this.tools.download(fileName, fileContent);
    }

    private extractFileName(contentDisposition: string): string {
        const regex = /filename="([^)]+)"/;
        const results = contentDisposition.match(regex);

        return results[1] || "tibagent";
    }
}
